import { autoinject, computedFrom } from "aurelia-framework";
import { BaseActivityConfiguration } from "../base-activity-configuration";
import { WorkflowConfigurationService } from "../../../../services/workflow/workflow-configuration-service";
import { QueriesClientService } from "../../../../services/queries/queries-client.services";
import { EntityFilterPropertyModel } from "../../../../models/queries/queries.models";
import { Reflection } from "../../../../utilities/reflection";

@autoinject()
export class EmailActivityConfiguration extends BaseActivityConfiguration {

    set isNotFreeAddress(value: boolean) {
        this.meta.isFreeAddress = !value;
        this.meta.email = null;
    }

    @computedFrom(Reflection.getPropertyPath<EmailActivityConfiguration>(x => x.meta.isFreeAddress))
    get isNotFreeAddress(): boolean {
        return !this.meta.isFreeAddress;
    }

    emailProps: EntityFilterPropertyModel[] = [];

    constructor(workflowConfigurationService: WorkflowConfigurationService, private queriesService: QueriesClientService) {
        super(workflowConfigurationService);
    }

    onActivated() {
        this.queriesService.getEntityModels().then(response => {
            const model = response.filter(x => x.uri == this.entity)[0];
            this.emailProps = model.filterProperties;
        });
        this.meta.entityUri = this.entity;
    }
}
